import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/css-utils'
import { ACADEMIC_AFFILIATION_FULL_VALUE } from '@/modules/surveys/configs/onboarding/current-job-pane-config'

export function AcademicBadge({
  academicAffiliation,
  className,
}: {
  academicAffiliation: string | null
  className?: string
}) {
  // we need this check, because `none` is a valid value
  if (academicAffiliation !== ACADEMIC_AFFILIATION_FULL_VALUE) return null

  return (
    <Badge
      variant="gray"
      className={cn('font-medium inline-block ml-2 px-1 rounded-sm', className)}
    >
      Academic
    </Badge>
  )
}
